// extracted by mini-css-extract-plugin
module.exports = {"summary-tip":"summary-tip-72786656eb5260275bcdb8df49b2534e"};